/**
 * Permission primitives — the whole vocabulary of authority in QMS360.
 *
 * ADR-0005: every role, shipped or custom, is composed from exactly these.
 * An Org Admin's role builder offers this list and nothing else, which is what
 * keeps custom roles checkable by the same engine as the defaults.
 *
 * Adding a primitive is a real decision: it widens what any role can express,
 * and every existing role has to be re-examined against it.
 */
export const PERMISSION_PRIMITIVES = [
    'create_edit',
    'submit',
    'approve_reject',
    'view_own',
    'view_all',
    'configure_masters',
    'manage_integrations',
    'manage_ai_settings',
    'export',
    'delegate',
];
/** Human-readable labels, for the role builder and the permission matrix editor. */
export const PERMISSION_LABELS = {
    create_edit: 'Create / Edit',
    submit: 'Submit',
    approve_reject: 'Approve / Reject',
    view_own: 'View Own',
    view_all: 'View All',
    configure_masters: 'Configure Masters',
    manage_integrations: 'Manage Integrations',
    manage_ai_settings: 'Manage AI Settings',
    export: 'Export',
    delegate: 'Delegate',
};
/**
 * What each permission lets a person do, as a phrase for a refusal: "Your roles
 * do not allow approving or sending back in QA/QC." A refusal is read by the
 * person refused, so it names the act, not the primitive.
 */
export const PERMISSION_ACTS = {
    create_edit: 'creating or editing records',
    submit: 'submitting',
    approve_reject: 'approving or sending back',
    view_own: 'viewing records',
    view_all: 'viewing everyone’s records',
    configure_masters: 'changing configuration',
    manage_integrations: 'managing integrations',
    manage_ai_settings: 'managing AI settings',
    export: 'exporting',
    delegate: 'delegating',
};
/**
 * The three applications (ADR-0001). These are separate front doors, not tabs.
 * Workspace Roles, escalation rule sets and AI settings are all scoped by one
 * of these keys.
 */
export const APP_KEYS = ['qaqc', 'lesson-learned', 'audit'];
export const APP_LABELS = {
    qaqc: 'QA/QC & Document Governance',
    'lesson-learned': 'Lesson Learned Management',
    audit: 'QMS Audit Management',
};
/** Short names for the top bar and the app switcher, where the full name will not fit. */
export const APP_SHORT_LABELS = {
    qaqc: 'QA/QC',
    'lesson-learned': 'Lesson Learned',
    audit: 'QMS Audit',
};
export function isAppKey(value) {
    return typeof value === 'string' && APP_KEYS.includes(value);
}
//# sourceMappingURL=primitives.js.map